import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=1f066b66&scoped=true&"
import script from "./AddEditForm.vue?vue&type=script&lang=js&"
export * from "./AddEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f066b66",
  null
  
)

export default component.exports